export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-1200-d3e0450e539b3a87a9a250b088108873.png";